<div *ngIf="notes.length === 0" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
    <span class="no-messages-text hint-text pt-32">There are no notes</span>
</div>

<div class="note-page" *fuseIfOnDom >
    <note-detail-item class="note-item" matRipple *ngFor="let note of notes; trackBy: trackByFn" 
      [note]="note" [readOnly]="readOnly" (click)="readNote(note)" (onPrint)="printNote(note);"
      [ngClass]="{'current-note':note?.id == currentNote?.id}">
    </note-detail-item>
</div>
